// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__ISDBh","label":"Input_label__BFK+z","input":"Input_input__dTRVa"};